import { Fragment, HtmlHTMLAttributes, memo } from "react";
import { BreadcrumbsContext } from "@tecorien/mimic-v2";
import classNames from "classnames";
import { Link } from "../Link";

import { ReactComponent as Arrow } from "./icons/arrow.svg";

import styles from "./style.module.scss";

export const Breadcrumbs = memo<HtmlHTMLAttributes<HTMLDivElement>>(({ className, ...props }) => {
  return (
    <BreadcrumbsContext.Consumer>
      {
        values => {
          const breadcrumbs = values.filter(x => x.href ?? x.to);
          return !values.length ? null : (
            <div
              aria-label="breadcrumbs"
              className={classNames(styles.root, className)}
              {...props}
            >
              {
                breadcrumbs
                  .map((x, index, array) => (
                    <Fragment key={`${x.href ?? x.to}_${index}`}>
                      <Link
                        linkType="s"
                        disabled={x.disabled}
                        component={x.href ? "a" : undefined}
                        href={x.href}
                        to={x.to}
                      >
                        {x.title}
                      </Link>
                      {
                        (index < (array.length - 1)) &&
                        <i className={styles.arrow}>
                          <Arrow />
                        </i>
                      }
                    </Fragment>
                  ))
              }
            </div>
          );
        }
      }
    </BreadcrumbsContext.Consumer>
  );
});
